module.exports = __webpack_public_path__ + "product-compound-capsule-06.jpg?801d1d289ccd067b4a92ed97f0f76880";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-compound-capsule-06.jpg
// module id = 103
// module chunks = 0